import { NewPasswordSettingForm } from "@/features/authenticate/components/newPasswordSettingForm";
import { useConfirmSignIn } from "@/features/authenticate/hooks/useConfirmSignIn";
import { Container, Stack } from "@mantine/core";

export const ResetPasswordPage = () => {
	const { handleSubmit } = useConfirmSignIn();

	return (
		<Container
			size="xl"
			style={{
				height: "100vh",
			}}
		>
			<Stack align="center" justify="center" h="100%">
				<NewPasswordSettingForm handleSubmit={handleSubmit} />
			</Stack>
		</Container>
	);
};
